import type { ProcessType } from 'shared/domain/process/types/model';

export interface IProcessUploader {
  PUT: (url: string, data: { workflowId: string }) => Promise<ProcessType>;
}

export type UploadProcessWorkflowChange = (
  uploader: IProcessUploader,
  workflowId: string,
  url: string
) => Promise<ProcessType>;

export function uploadProcessWorkflowChange(
  uploader: IProcessUploader,
  workflowId: string,
  url: string
): Promise<ProcessType> {
  return uploader.PUT(url, { workflowId });
}
